import React, { Component } from "react"
import { SettingsFormField } from "./settings/settings_form_field"
import { SettingsSection } from "./settings/settings_section"
import { appNums } from "../common/nums/app_nums"
import { appStrings } from "../common/strings/app_strings"
import moment from "moment-timezone"
import Checkbox from "react-bootstrap/lib/Checkbox"
import Button from "react-bootstrap/lib/Button"

const { MIN_PASSWORD_LENGTH } = appNums
const { profileStrings, saveChanges } = appStrings
const {
    changeName: { nameTitle, nameDetail, fullName },
    changePassword: {
        passwordTitle,
        passwordDetail,
        currentPassword,
        newPassword,
        confirmNewPassword,
    },
    dateTime,
    timeZone,
    dateTimeDetail,
    notifications,
    weeklyReportsTitle,
    remindersTitle,
    announcementsTitle,
    educationTitle,
} = profileStrings

const timeZones = moment.tz.names()

const notificationsObj = {
    weeklyReports: {
        id: "weeklyReports",
        name: weeklyReportsTitle,
    },
    reminders: {
        id: "reminders",
        name: remindersTitle,
    },
    announcements: {
        id: "announcements",
        name: announcementsTitle,
    },
    education: {
        id: "education",
        name: educationTitle,
    },
}

class ProfileSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fullName: "",
            saveNameEnabled: false,
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            savePasswordEnabled: false,
            saveDateTimeEnabled: false,
            timeZone: "",
            weeklyReports: true,
            reminders: true,
            announcements: true,
            education: true,
            saveNotificationsEnabled: false,
        }
        this.notificationsRef = null
        this.updateFormField = this.updateFormField.bind(this)
        this.saveName = this.saveName.bind(this)
        this.savePassword = this.savePassword.bind(this)
        this.saveDateTime = this.saveDateTime.bind(this)
    }

    updateFormField(value, key) {
        this.setState({ [key]: value }, () => {
            const newState = {
                ...this.state,
                [key]: value,
            }
            // validation
            if (key === "fullName") {
                const shouldEnable = !!newState.fullName
                this.setState({ saveNameEnabled: shouldEnable })
            }
            if (
                key === "newPassword" ||
                key === "confirmNewPassword" ||
                key === "currentPassword"
            ) {
                const shouldEnable =
                    newState.confirmNewPassword === newState.newPassword &&
                    !!newState.currentPassword &&
                    newState.confirmNewPassword.length >= MIN_PASSWORD_LENGTH

                this.setState({ savePasswordEnabled: shouldEnable })
            }
            if (key === "timeZone") {
                this.setState({ saveDateTimeEnabled: true })
            }
            if (Object.keys(notificationsObj).indexOf(key) != -1) {
                this.setState({ saveNotificationsEnabled: true })
            }
        })
    }

    componentDidUpdate(prevProps) {
        const {
            notificationPreferences: {
                education,
                reminders,
                weeklyReports,
                announcements,
            },
            timezone,
            name,
        } = this.props.profile
        const prevProfile = prevProps.profile
        // receive changes to profile name
        const fullName = name
        if (prevProfile.name !== fullName) {
            this.setState({
                fullName,
                saveNameEnabled: false,
            })
        }
        // receive changes from ui.clearSettingsPassword
        if (
            !!this.props.ui.clearSettingsPassword &&
            prevProps.ui.clearSettingsPassword !==
                this.props.ui.clearSettingsPassword
        ) {
            this.setState({
                savePasswordEnabled: false,
                newPassword: "",
                confirmNewPassword: "",
            })
        }
        if (prevProfile.timezone !== timezone) {
            this.setState({ timeZone: timezone })
        }

        if (
            prevProfile.notificationPreferences.weeklyReports !== weeklyReports
        ) {
            this.setState({
                weeklyReports,
            })
        }
        if (prevProfile.notificationPreferences.reminders !== reminders) {
            this.setState({ reminders })
        }
        if (
            prevProfile.notificationPreferences.announcements !== announcements
        ) {
            this.setState({
                announcements,
            })
        }
        if (prevProfile.notificationPreferences.education !== education) {
            this.setState({ education })
        }
    }

    scrollToNotifications = () => {
        var topPos = this.notificationsRef.offsetTop
        document.getElementById("settings-scroller").scrollTop = topPos
    }

    saveName() {
        const { saveNameEnabled, fullName } = this.state
        if (saveNameEnabled) {
            this.props.updateUserName(fullName)
        }
    }

    savePassword() {
        const { savePasswordEnabled, currentPassword, newPassword } = this.state
        this.props.changePassword
        if (savePasswordEnabled) {
            this.props.changePassword(currentPassword, newPassword)
        }
    }

    componentDidMount() {
        const {
            timezone,
            notificationPreferences,
            name: fullName,
        } = this.props.profile

        this.setState({
            fullName,
            timeZone: timezone || moment.tz.guess(),
            ...notificationPreferences,
        })

        if (
            this.notificationsRef &&
            this.props.scrollToNotificationPreferences
        ) {
            this.scrollToNotifications()
        }
    }

    saveDateTime() {
        this.setState({ saveDateTimeEnabled: false }, () =>
            this.props.updateUserTimezone(this.state.timeZone),
        )
    }

    saveNotifications = () => {
        const {
            weeklyReports,
            reminders,
            announcements,
            education,
        } = this.state
        const newNotificationPreferences = {
            weeklyReports,
            reminders,
            announcements,
            education,
        }
        /// update user notifications
        this.setState({ saveNotificationsEnabled: false }, () =>
            this.props.updateNotificationPreferences(
                newNotificationPreferences,
            ),
        )
    }

    render() {
        const { profile } = this.props
        return (
            <div className="profile-settings">
                <SettingsSection
                    sectionTitle={nameTitle}
                    details={nameDetail}
                    isDisabled={!this.state.saveNameEnabled}
                    saveAction={this.saveName}
                    profile={profile}
                    hasAvatar={true}
                >
                    <div className="settings-row">
                        <SettingsFormField
                            focus={true}
                            className=""
                            id={"fullName"}
                            label={fullName}
                            value={this.state.fullName}
                            onChangeAction={this.updateFormField}
                        />
                    </div>
                </SettingsSection>
                <SettingsSection
                    sectionTitle={passwordTitle}
                    details={passwordDetail}
                    isDisabled={!this.state.savePasswordEnabled}
                    saveAction={this.savePassword}
                    hasAvatar={false}
                >
                    <div className="section-column">
                        <SettingsFormField
                            className=""
                            id={"currentPassword"}
                            label={currentPassword}
                            value={this.state.currentPassword}
                            onChangeAction={this.updateFormField}
                            type="password"
                            placeholder={currentPassword}
                        />
                        <SettingsFormField
                            className=""
                            id={"newPassword"}
                            label={newPassword}
                            value={this.state.newPassword}
                            onChangeAction={this.updateFormField}
                            type="password"
                            placeholder={newPassword}
                        />
                        <SettingsFormField
                            className=""
                            id={"confirmNewPassword"}
                            label={confirmNewPassword}
                            value={this.state.confirmNewPassword}
                            onChangeAction={this.updateFormField}
                            type="password"
                            placeholder={confirmNewPassword}
                        />
                    </div>
                </SettingsSection>
                <SettingsSection
                    sectionTitle={dateTime}
                    details={dateTimeDetail}
                    isDisabled={!this.state.saveDateTimeEnabled}
                    saveAction={this.saveDateTime}
                    hasAvatar={false}
                >
                    <div className="section-column">
                        <div className="settings-form-field-wrapper">
                            {timeZone}
                            <select
                                className="settings-select form-control"
                                id="timeZone"
                                value={this.state.timeZone}
                                onChange={event =>
                                    this.updateFormField(
                                        event.target.value,
                                        "timeZone",
                                    )
                                }
                            >
                                {timeZones.map((zone, i) => (
                                    <option value={zone} key={i}>
                                        {zone}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </SettingsSection>
                <div
                    className="section-wrapper full-width"
                    ref={ref => (this.notificationsRef = ref)}
                >
                    <div className="settings-forms-container">
                        <h4>{notifications}</h4>
                        <Button
                            onClick={this.saveNotifications}
                            className="btn btn-primary"
                            disabled={!this.state.saveNotificationsEnabled}
                        >
                            {saveChanges}
                        </Button>
                    </div>
                    <div className="section-column">
                        {Object.values(notificationsObj).map(notification => {
                            const currentValue = this.state[notification.id]
                            return (
                                <Checkbox
                                    key={notification.id}
                                    checked={currentValue}
                                    onChange={_ =>
                                        this.updateFormField(
                                            !currentValue,
                                            notification.id,
                                        )
                                    }
                                >
                                    {notification.name}
                                </Checkbox>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default ProfileSettings



// WEBPACK FOOTER //
// ./src/components/profile_settings.jsx